import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // verifica se usuário está logado
        authenticated: false,
        // dados do usuário logado
        user: null,
        // data do últmo login
        ultimologin: null,
        // manter usuário logado
        keepLogged: false,
        // chama função de pegar dados do usuário
        getUserInfo: false,
        // chama função de logout do usuário
        logoutUser: false,

        loadersCount: 0,
        context: null,
        hide: {
            hideInfo: true,
            infoIsHidden: true,
            mapsIsHidden: true,
        },
        language: 'pt-br',
        accessDenied: {
            value: false,
            title: null,
        },
        partnerSystemHasLayout: {
            color_intensity: 0.9,
            primary_color: '#4F2584',
            secondary_color: '#ffb548',
            light_color: '#7A3FD8',
            dark_color: '#361C60',
            url_logotipo_web: null,
            partner_nome: 'Sovis App',
        },
        showMenu: true,
        // Informações da tabela EMPRESAS do MBSALES
        // No aplicativo, utiliza as informações de quantidade de casas decimais
        empresas: {
            disponivel: true,
            data: [],
        },
        app_modulo: {
            disponivel: true,
            data: [],
        },
        app_tela: {
            disponivel: true,
            data: [],
        },
        modulopda: {
            disponivel: true,
            data: [],
        },
    },
    mutations: {
        authenticated: (state, { value }) => {
            state.authenticated = value;
        },
        user: (state, { value }) => {
            state.user = value;
        },
        ultimologin: (state, { value }) => {
            state.ultimologin = value;
        },
        keepLogged: (state, { value }) => {
            state.keepLogged = value;
        },
        getUserInfo: (state, { value }) => {
            state.getUserInfo = value;
        },
        logoutUser: (state, { value }) => {
            state.logoutUser = value;
        },
        partnerSystemHasLayout: (state, { value }) => {
            state.partnerSystemHasLayout = value;
        },
        context: (state, { value }) => {
            state.context = value;
        },

        language: (state, { language }) => {
            state.language = language;
        },
        hideInfo: (state, { hideInfo }) => {
            state.hide.hideInfo = hideInfo;
        },
        accessDenied: (state, { value, title }) => {
            state.accessDenied.value = value;
            state.accessDenied.title = title;
        },
        infoIsHidden: (state, { infoIsHidden }) => {
            state.hide.infoIsHidden = infoIsHidden;
            state.hide.mapsIsHidden = infoIsHidden;
        },
        mapsIsHidden: (state, { mapsIsHidden }) => {
            state.hide.mapsIsHidden = mapsIsHidden;
        },
        addLoader(state) {
            state.loadersCount++;
        },
        removeLoader(state) {
            state.loadersCount--;
        },
        showMenu: (state, { value }) => {
            state.showMenu = value;
        },
        toogleMenu(state) {
            state.showMenu = !state.showMenu;
        },

        empresasDisponivel(state, { value }) {
            state.empresas.disponivel = value;
        },
        empresasData(state, { value }) {
            state.empresas.data = value;
        },
        app_moduloDisponivel(state, { value }) {
            state.app_modulo.disponivel = value;
        },
        app_moduloData(state, { value }) {
            state.app_modulo.data = value;
        },
        app_telaDisponivel(state, { value }) {
            state.app_tela.disponivel = value;
        },
        app_telaData(state, { value }) {
            state.app_tela.data = value;
        },
        modulopdaDisponivel(state, { value }) {
            state.modulopda.disponivel = value;
        },
        modulopdaData(state, { value }) {
            state.modulopda.data = value;
        },
    },
    actions: {
        authenticated: ({ commit }, { value }) => {
            commit('authenticated', { value: value });
        },
        user: ({ commit }, { value }) => {
            commit('user', { value: value });
        },
        ultimologin: ({ commit }, { value }) => {
            commit('ultimologin', { value: value });
        },
        keepLogged: ({ commit }, { value }) => {
            commit('keepLogged', { value: value });
        },
        getUserInfo: ({ commit }, { value }) => {
            commit('getUserInfo', { value: value });
        },
        logoutUser: ({ commit }, { value }) => {
            commit('logoutUser', { value: value });
        },
        partnerSystemHasLayout: ({ commit }, { value }) => {
            commit('partnerSystemHasLayout', { value: value });
        },
        context: ({ commit }, { value }) => {
            commit('context', { value: value });
        },

        hideInfo: ({ commit }, { hideInfo }) => {
            commit('hideInfo', { hideInfo: hideInfo });
        },
        infoIsHidden: ({ commit }, { infoIsHidden }) => {
            commit('infoIsHidden', { infoIsHidden: infoIsHidden });
        },
        mapsIsHidden: ({ commit }, { mapsIsHidden }) => {
            commit('mapsIsHidden', { mapsIsHidden: mapsIsHidden });
        },
        language: ({ commit }, { language }) => {
            commit('language', { language: language });
        },
        accessDenied: ({ commit }, { value, title }) => {
            commit('accessDenied', { value: value, title: title });
        },
        showMenu: ({ commit }, { value }) => {
            commit('showMenu', { value: value });
        },
        toogleMenu: ({ commit }) => {
            commit('toogleMenu');
        },

        empresasDisponivel: ({ commit }, { value }) => {
            commit('empresasDisponivel', { value: value });
        },
        empresasData: ({ commit }, { value }) => {
            commit('empresasData', { value: value });
        },
        app_moduloDisponivel: ({ commit }, { value }) => {
            commit('app_moduloDisponivel', { value: value });
        },
        app_moduloData: ({ commit }, { value }) => {
            commit('app_moduloData', { value: value });
        },
        app_telaDisponivel: ({ commit }, { value }) => {
            commit('app_telaDisponivel', { value: value });
        },
        app_telaData: ({ commit }, { value }) => {
            commit('app_telaData', { value: value });
        },
        modulopdaDisponivel: ({ commit }, { value }) => {
            commit('modulopdaDisponivel', { value: value });
        },
        modulopdaData: ({ commit }, { value }) => {
            commit('modulopdaData', { value: value });
        },
    },
    getters: {
        isLoading: (state) => state.loadersCount > 0,
    },
});
